import Emoji, { Emoji as NotPureEmoji } from './Emoji';
import * as Types from './Emoji.d';
import { StyledEmoji } from './Emoji.styled';

export { NotPureEmoji as Emoji, StyledEmoji };
export type EmojiProps = Types.EmojiProps;
export type EmojiNameType = Types.EmojiNameType;
export default Emoji;
